import request from "@/utils/request";

export function saveBo (data){
  return request({
    url:'/osp/materialCommerce/saveBo',
    method:'post',
    data: data
  })
}

export function updateBo (data){
  return request({
    rul:'/osp/materialCommerce/updateByBo',
    method:'post',
    data: data
  })
}
